/**
 * Marque d'homonymie : AFFICHAGE UNIQUEMENT.
 *
 * L'astérisque est derive de `dossiers.homonyme` (0007) au moment de rendre le
 * nom. Il n'est jamais ecrit dans `nom` ni `prenom`, ni dans un nom de fichier,
 * ni dans l'en-tete d'impression d'un rapport remis a l'apprenant.
 */

export const MARQUE_HOMONYME = '*'

export const INFOBULLE_HOMONYME = 'Homonyme : vérifier l’e-mail avant d’ouvrir'

/** L'astérisque à afficher après le nom, ou null si le dossier n'est pas homonyme. */
export function marqueHomonyme(homonyme: boolean): string | null {
  return homonyme ? MARQUE_HOMONYME : null
}
